import { LESSON_UPDATED_EVENT } from '@h2/common/constants'

import * as h2Api from '../../h2Api'

export const ASSIGNMENT_LISTING_LOADED = 'ASSIGNMENT_LISTING_LOADED'

export const ASSIGNMENT_LOADED = 'ASSIGNMENT_LOADED'

export const ASSIGNMENT_MOVE_TO = 'ASSIGNMENT_MOVE_TO'

export const ASSIGNMENT_TASK_SAVE = 'ASSIGNMENT_TASK_SAVE'

export const ASSIGNMENT_TASK_APPEND_LIST = 'ASSIGNMENT_TASK_APPEND_LIST'

export const REQUEST_PLAN_SEQUENCE = 'ASSIGNMENT_REQUEST_PLAN_SEQUENCE'

export const MARK_PLAN_INTRO_SEEN = 'ASSIGNMENT_MARK_PLAN_INTRO_SEEN'

export const MARK_PLAN_COMPLETE = 'ASSIGNMENT_MARK_PLAN_COMPLETE'

export const UPDATE_STORED = 'ASSIGNMENT_UPDATE_STORED'

export const UPDATE_STORED_TASK = 'UPDATE_STORED_TASK'

export const ASSIGNMENT_SEQUENCE_LOADED = 'ASSIGNMENT_SEQUENCE_LOADED'

export const listAssignments = () => dispatch => {
  return dispatch(h2Api.get(`/plans/list`)({ type: ASSIGNMENT_LISTING_LOADED }))
}

export const deleteAssignments = planId => dispatch => {
  return dispatch(h2Api.doDelete(`/plans/${planId}`)({ type: ASSIGNMENT_LISTING_LOADED }))
}

export const loadAssignment = (id, force) => (dispatch, getState) => {
  const plan = getState().planning.assignmentDetail.data.result
  const planId = plan && plan.id

  console.log(plan, planId, id, !!force)

  if (!!force || !planId || id != planId) {
    return dispatch(h2Api.get(`/plans/${id}`)({ type: ASSIGNMENT_LOADED }))
  }

  return Promise.resolve(plan)
}

/**
 * This is a separate method since educators can see assignments that aren't assigned to them, but we don't want to
 * return it from the main call, lest they accidentally start completing the plan that will be assigned
 */
export const loadAssignmentForPreview = (id, force) => (dispatch, getState) => {
  const plan = getState().planning.assignmentDetail?.data?.result

  console.log(`Received load request for: ${id}, is forced: ${force}`, plan, getState())
  const planId = plan && plan.id

  console.log(plan, planId, id, !!force)

  if (!!force || !planId || id != planId) {
    return dispatch(h2Api.get(`/plans/preview/${id}`)({ type: ASSIGNMENT_LOADED }))
  }

  return Promise.resolve(plan)
}

export const loadSequenceForPreview = sequenceId => (dispatch, getState) => {
  return dispatch(
    h2Api.get(`/admin/lessons/sequence/${sequenceId}`)({
      type: ASSIGNMENT_SEQUENCE_LOADED
    })
  )
}

export const movePageTo = page => dispatch => {
  return dispatch({ type: ASSIGNMENT_MOVE_TO, page })
}

export const saveTask = (planId, taskId, data) => dispatch => {
  const formData = new FormData()
  const { file, ...task } = data

  if (file) {
    Array.from(file).forEach(f => {
      formData.append('file', f)
    })
  }

  //formData.fi
  const json = JSON.stringify(task)

  formData.append('json', json)

  return dispatch(
    h2Api.postFile(
      `/plans/${planId}/${taskId}`,
      formData
    )({ type: ASSIGNMENT_TASK_SAVE, taskId })
  )
}

export const requestSequence = ids => dispatch => {
  return dispatch(
    h2Api.post('/plans/request/byids', { ids })({ type: REQUEST_PLAN_SEQUENCE })
  )
}

export const markIntroRead = planId => dispatch => {
  return dispatch(
    h2Api.post(`/plans/${planId}/intro`, {})({ type: MARK_PLAN_INTRO_SEEN })
  ).then(t => {
    dispatch({ type: UPDATE_STORED, data: t })

    return t
  })
}

//this doesn't actually set any persistent state, just updates the store
export const tempSetStatusComplete = task => dispatch => {
  const newTask = {
    ...task,
    status: {
      id: 3,
      name: 'Completed'
    }
  }

  return Promise.resolve(dispatch({ type: UPDATE_STORED_TASK, data: newTask }))
}

export const markComplete = planId => dispatch => {
  return dispatch(
    h2Api.post(`/plans/${planId}/complete`, {})({ type: MARK_PLAN_COMPLETE })
  ).then(t => {
    dispatch({ type: UPDATE_STORED, data: t })
    window.dispatchEvent(new CustomEvent(LESSON_UPDATED_EVENT))

    return t
  })
}

export const replaceVariables = original => {
  if (!original) {
    return original
  }

  const re = /%%(.*?)%%/g

  return original.replace(re, (m, p1) => {
    return dynamicValues[p1] || m
  })
}
